import {TagFrequency} from "stuen-common";
import {setTagFrequency} from "../api/song";

export const TagFrequencyItem = ({tag}:{tag:TagFrequency}) => {
    function setFrequency(number: number) {
        setTagFrequency(new TagFrequency(tag.tag, number))
    }

    return (<div>
        {tag.tag}
        <input type="number" className="text-black" value={tag.frequency} onChange={(e) => setFrequency(Number(e.target.value))} />
    </div>);
}